import React from 'react';

const parties = [
  { name: 'VVD', color: 'from-blue-400 to-blue-600', seats: 24, leader: 'Dilan Yeşilgöz' },
  { name: 'PVV', color: 'from-orange-400 to-orange-600', seats: 37, leader: 'Geert Wilders' },
  { name: 'NSC', color: 'from-purple-400 to-purple-600', seats: 20, leader: 'Pieter Omtzigt' },
  { name: 'GroenLinks-PvdA', color: 'from-green-400 to-green-600', seats: 25, leader: 'Frans Timmermans' },
  { name: 'CDA', color: 'from-cyan-400 to-cyan-600', seats: 5, leader: 'Henri Bontenbal' },
  { name: 'D66', color: 'from-yellow-400 to-yellow-600', seats: 7, leader: 'Rob Jetten' },
  { name: 'SP', color: 'from-red-400 to-red-600', seats: 8, leader: 'Jimmy Dijk' },
  { name: 'Partij voor de Dieren', color: 'from-emerald-400 to-emerald-600', seats: 6, leader: 'Esther Ouwehand' },
];

export default function PartijenPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-5xl font-bold mb-12 text-center text-gray-800">Politieke Partijen</h1>
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {parties.sort((a, b) => b.seats - a.seats).map(party => (
          <div key={party.name} className="bg-white rounded-xl shadow-lg p-6 flex items-center gap-4">
            <div className={`w-16 h-16 bg-gradient-to-r ${party.color} rounded-full flex items-center justify-center text-white font-bold text-xl`}>
              {party.name.charAt(0)}
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold">{party.name}</h3>
              <p className="text-gray-600 text-sm">{party.leader}</p>
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-gray-800">{party.seats}</div>
              <div className="text-sm text-gray-500">zetels</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
